<div
  class="card-container"
  [ngClass]="{ 'no-available': valid && product?.isUnavailable() }"
  (click)="openDialog(product)">
  <div style="height: 100%">
    <div class="id-heart-container">
      <p class="id">{{ product.id }}</p>
      <mat-icon
        *ngIf="!isFavourite && resident && valid"
        (click)="addProductToFavourites($event, product)"
        [svgIcon]="'favourites-header-icon'"
        class="favourites-header-icon"></mat-icon>
      <mat-icon
        *ngIf="isFavourite && resident && valid"
        (click)="removeProductFromFavourites($event, product)"
        [svgIcon]="'heart-icon'"
        class="heart-icon favourite"
        [class.favourite-pump]="favouritePump"
        (animationend)="onFavouritePumpEnd()"></mat-icon>
    </div>
    <div class="product-card-part" *ngIf="valid">
      <div class="image-container">
        <img
          [src]="product.images[0].src"
          alt="product image"
          class="product-image" />
      </div>
      <div class="flex column gap-8px">
        <p class="brand">{{ product.brand.brandName }}</p>
        <p>
          <b lang="de" class="name" [class.has-deposit]="hasDeposit">
            <span class="name-text">{{ displayProductName }}</span>
            <span *ngIf="hasDeposit" class="deposit-label">
              {{ isProductNameTruncated ? '... ' : '' }}({{ depositLabel }})
            </span>
          </b>
        </p>
      </div>
      <div *ngIf="product.isNew" style="--color: #8f85d5" class="product-mark">
        NEU
      </div>
      <div
        *ngIf="product.isUnavailable()"
        style="--color: #42405f"
        class="product-mark">
        {{ unavailabilityText }}
      </div>
    </div>
    <div *ngIf="!valid" class="invalid-product">
      <div class="invalid-info">
        <mat-icon svgIcon="error-icon"></mat-icon>
        <p><b>Die eingegebene Produktnummer ist ungültig.</b></p>
      </div>
      <button
        class="remove-invalid-button"
        (click)="removeInvalidProduct($event)">
        <mat-icon svgIcon="trash-icon"></mat-icon>
      </button>
    </div>
  </div>
  <div class="product-card-part" *ngIf="valid">
    <div class="additional-info">
      <div>
        <p class="size">{{ product.inhalt }}</p>
        <p *ngIf="hasDeposit" class="deposit-info">
          zzgl. {{ depositAmountText }}€ Pfand
        </p>
      </div>
      <p class="price">€ {{ product.price | number: '1.2-2' }}</p>
    </div>
    <p *ngIf="quantityLimitText" class="quantity-limit">
      {{ quantityLimitText }}
    </p>
    <app-product-counter
      class="product-counter"
      [counter]="productCount"
      [listOfNeedsProduct]="listOfNeedsProduct"
      [canIncrease]="canIncrease"
      [maxQuantity]="maxQuantity"
      (click)="counterClick($event)"
      (counterChange)="onCounterChange($event)"></app-product-counter>
    <div
      *ngIf="product.isUnavailable() && valid"
      class="not-available-container">
      <button
        class="alternative-button"
        *ngIf="showAlternativeButton"
        (click)="showAlternative()">
        {{ listOfNeedsProduct ? 'Alternative wählen' : 'Alternative anzeigen' }}
      </button>
    </div>
  </div>
</div>
